import React, { useEffect } from 'react';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import cookie from 'react-cookies';
import { IntlProvider } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import PropTypes from 'prop-types';
import { ProgressCircular } from '@americanexpress/dls-react';
import { Helmet } from 'react-helmet';
import childRoutes from '../childRoutes';
import { reducer } from '../ducks';
import { AMERICAN_EXPRESS_DOMAIN } from '../constants';
import { getFormattedLocale } from '../utils/utils';

const AxpCommercialReconRoot = ({
  languageData,
  locale,
  children,
}) => {
  /* istanbul ignore next -- unable to mock the Intl object in testing */
  useEffect(() => {
    console.log('@@testing vulnerability fix');
    /* eslint-disable no-underscore-dangle -- what */
    if (typeof Intl?.__disableRegExpRestore === 'function') {
      Intl.__disableRegExpRestore();
    }
    /* eslint-enable no-underscore-dangle -- what */
  }, []);

  useEffect(() => {
    cookie.save('selectedLang', getFormattedLocale(locale), {
      path: '/',
      domain: AMERICAN_EXPRESS_DOMAIN,
    });
  }, [locale]);

  if (Object.entries(languageData).length === 0) {
    return <ProgressCircular />;
  }

  return (
    <div>
      <IntlProvider locale={locale} messages={languageData}>
        <Helmet
          link={[
            {
              rel: 'stylesheet',
              href: 'https://www.aexp-static.com/cdaas/dls/packages/@americanexpress/dls/7.14.0/stylesheets/dls-max.min.css',
            },
            {
              rel: 'icon',
              href: 'https://www.americanexpress.com/favicon.ico',
            },
          ]}
          titleTemplate="American Express - %s"
          htmlAttributes={{ lang: locale }}
          meta={[
            { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
            { charset: 'utf-8' },
            {
              name: 'viewport',
              content: 'width=device-width, initial-scale=1.0',
            },
          ]}
          title="@ Work Reconciliation"
        />
        {children}
      </IntlProvider>
    </div>
  );
};

export const TestableAxpCommercialReconRoot = AxpCommercialReconRoot;

AxpCommercialReconRoot.propTypes = {
  languageData: PropTypes.shape({}).isRequired,
  locale: PropTypes.string.isRequired,
  children: PropTypes.node,
};

AxpCommercialReconRoot.childRoutes = childRoutes;

// Read about appConfig:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/App-Configuration.md
/* istanbul ignore next */
if (!global.BROWSER) {
  AxpCommercialReconRoot.appConfig = require('../appConfig').default;
}

export const loadModuleData = async ({ store: { dispatch } }) => {
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      fallbackLocale: 'en-US',
    })
  );
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      locale: 'en-CA',
      fallbackLocale: 'en-US',
    })
  );
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      locale: 'en-US',
      fallbackLocale: 'en-US',
    })
  );
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      locale: 'es-ES',
      fallbackLocale: 'en-US',
    })
  );
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      locale: 'pt-BR',
      fallbackLocale: 'en-US',
    })
  );
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      locale: 'it-IT',
      fallbackLocale: 'en-US',
    })
  );
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      locale: 'fr-FR',
      fallbackLocale: 'en-US',
    })
  );
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      locale: 'fr-CA',
      fallbackLocale: 'en-US',
    })
  );
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      locale: 'en-GB',
      fallbackLocale: 'en-US',
    })
  );
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      locale: 'nl-NL',
      fallbackLocale: 'en-US',
    })
  );
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      locale: 'sv-SE',
      fallbackLocale: 'en-US',
    })
  );
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      locale: 'es-MX',
      fallbackLocale: 'en-US',
    })
  );
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      locale: 'en-AU',
      fallbackLocale: 'en-US',
    })
  );
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      locale: 'de-DE',
      fallbackLocale: 'en-US',
    })
  );
  await dispatch(
    loadLanguagePack('axp-commercial-reconciliation-root', {
      locale: 'es-LA',
      fallbackLocale: 'en-US',
    })
  );
};

AxpCommercialReconRoot.holocron = {
  name: 'axp-commercial-reconciliation-root',
  reducer,
  loadModuleData,
};

export default oneAppModuleWrapper('axp-commercial-reconciliation-root')(
  AxpCommercialReconRoot
);
